import { SelectOption } from '@globaleris/ui.library'
import { EnumCommodity } from '../api'
import { EnumNivelDesglose } from '../api/Argentia/enums/enumNivelDesglose'
import { enumToSelectOptionArray } from './enumHelper'

export const getFilteredBreakdownOptions = (commodity?: EnumCommodity): SelectOption[] => {
  const all = enumToSelectOptionArray(EnumNivelDesglose, 'enums:EnumNivelDesglose')
  if (commodity === EnumCommodity.GasNatural) {
    return all.filter(o => o.value === EnumNivelDesglose.Diario)
  }
  if (commodity === EnumCommodity.Electricidad) {
    return all.filter(o =>
      [
        EnumNivelDesglose.Horario,
        EnumNivelDesglose.CuartoHorario,
        EnumNivelDesglose.DiarioPeriodo
      ].includes(o.value as EnumNivelDesglose)
    )
  }
  return all
}
